/**
 * An observation value rendered for display.
 *
 * Ledger content is typed `unknown` — an aspect can carry an object — and `String(value)`
 * on one yields '[object Object]', which is what the user would then read in a Stream
 * entry or a Trajectory track (S6551). Objects are serialised instead of stringified.
 */
export function toDisplayValue(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value) ?? '';
    } catch {
      // Circular or otherwise unserialisable: an empty cell beats '[object Object]'.
      return '';
    }
  }
  return String(value);
}
